import { AccessorsMutatorsDecorator, Model } from '../../helpers';
import { BillingTransaction } from "./billing-transaction.model";
import { Subscription } from "./subscription.model";

/**
 * @class BillingInvoice
 */
export class BillingInvoice extends Model {

    static get UNPAID_STATUS() {

        return 0;
    }

    static get PAID_STATUS() {

        return 1;
    }

    static get PARTIALLY_PAID_STATUS() {

        return 2;
    }

    static get OVERDUE_STATUS() {

        return 3;
    }

    static get PARTIALLY_REFUNDED_STATUS() {

        return 4;
    }

    static get REFUNDED_STATUS() {

        return 5;
    }

    static get STATUSES() {

        return [
            this.UNPAID_STATUS,
            this.PAID_STATUS,
            this.PARTIALLY_PAID_STATUS,
            this.OVERDUE_STATUS,
            this.PARTIALLY_REFUNDED_STATUS,
            this.REFUNDED_STATUS,
        ];
    }

    static get FORMATTED_STATUSES() {

        return {
            [this.UNPAID_STATUS]: 'UNPAID',
            [this.PAID_STATUS]: 'PAID',
            [this.PARTIALLY_PAID_STATUS]: 'PARTIALLY_PAID',
            [this.OVERDUE_STATUS]: 'OVERDUE',
            [this.PARTIALLY_REFUNDED_STATUS]: 'PARTIALLY_REFUNDED',
            [this.REFUNDED_STATUS]: 'REFUNDED',
        }
    }

    setBillingTransactions(transactions = []) {

        return transactions.map(transaction => transaction instanceof BillingTransaction ? transaction : new BillingTransaction(transaction));
    }

    setSubscription(subscription = null) {

        if (!subscription) {

            return null;
        }

        return subscription instanceof Subscription ? subscription : new Subscription(subscription);
    }

    isNotPaid() {

        return this.status !== this.constructor.PAID_STATUS;
    }

    isNotBlockedByRefund() {

        return this.blocked_by_refund !== true;
    }

    hasManualTransaction() {

        return this.billing_transactions.some(transaction => transaction.isManual());
    }

    formatStatus() {

        return this.constructor.FORMATTED_STATUSES[this.status];
    }

    getPaidTransactions() {

        return (this.billing_transactions || []).filter(transaction => {

            return transaction.status === BillingTransaction.PAID_STATUS && transaction.is_refund === BillingTransaction.ACTION_PAYMENT;
        })
    }
}

AccessorsMutatorsDecorator(
    'id',
    'ident',
    'property_id',
    'balance',
    'total',
    'status',
    'due_date',
    'paid_date',
    'billing_transactions',
    'attachment',
    'created_at',
    'subscription_id',
    'paid_transactions',
    'subscription',
    'blocked_by_refund',
    'addons_expired',
    'is_sms_type',
    'is_shomoos_type',
    'addons',
)(BillingInvoice);



// WEBPACK FOOTER //
// ./src/pms-api/models/billing-invoice.model.js